export default __webpack_public_path__ + "media/images/deped-icon-blue-dbb3a8c5.svg";